import { AboutPage } from "components/Parts/Organisms/AboutPage";
import { Auth } from "components/Parts/Organisms/Auth";
import React from "react";

export const About = React.memo(() => (
  <Auth>
    <AboutPage />
  </Auth>
));
